var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vld-overlay is-active is-full-page vld-background",attrs:{"z-index":"0"}},[_c('b-spinner',{staticClass:"m-5",attrs:{"variant":"primary","label":"Cargando..."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }